"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gracefulRequest = exports.defaultGracefulRequestOptions = exports.getGracefulProps = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
var scenarios_1 = require("../scenarios");
var provider_1 = require("../provider");
var lodash_1 = require("lodash");
var getGracefulProps = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var typeOfRequest, response, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                typeOfRequest = params.typeOfRequest, response = params.response;
                _a = typeOfRequest;
                switch (_a) {
                    case 'Axios': return [3 /*break*/, 1];
                    case 'Fetch': return [3 /*break*/, 2];
                }
                return [3 /*break*/, 4];
            case 1: return [2 /*return*/, (0, scenarios_1.createGracefulPropsWithAxios)(response)];
            case 2: return [4 /*yield*/, (0, scenarios_1.createGracefulPropsWithFetch)(response.clone())];
            case 3: return [2 /*return*/, _b.sent()];
            case 4: throw new Error('Invalid typeOfRequest parameter');
        }
    });
}); };
exports.getGracefulProps = getGracefulProps;
exports.defaultGracefulRequestOptions = {
    enableRetry: true,
    exponentialBackOffFn: scenarios_1.exponentialBackOffFn,
    maxBackOffTime: provider_1.maxBackOffTime,
};
/**
 * Makes a graceful request using either Axios or Fetch.
 *
 * @param {'Axios' | 'Fetch'} typeOfRequest - The type of request to make.
 * @param {() => Promise<AxiosOrFetch<T>>} requestFnc - A function that returns a promise that resolves to the response object.
 * @param {(err: AxiosOrFetch<T> | null, response: AxiosOrFetch<T> | null) => void} [callback=() => {}] - An optional callback function that is called with the error and response objects.
 * @param {GracefulRequestOptions} configOptions - config options to customize retry behavior.
 * @returns {Promise<AxiosOrFetch<T>>} - A promise that resolves to the response object.
 */
function gracefulRequest(typeOfRequest, requestFnc, callback, configOptions, retryAttempts) {
    if (callback === void 0) { callback = lodash_1.noop; }
    if (configOptions === void 0) { configOptions = exports.defaultGracefulRequestOptions; }
    if (retryAttempts === void 0) { retryAttempts = 0; }
    return __awaiter(this, void 0, void 0, function () {
        var options, findIsRetry, retryRequest, response, err_1;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    options = __assign(__assign({}, exports.defaultGracefulRequestOptions), configOptions);
                    findIsRetry = function () { return (retryAttempts > 0 ? true : false); };
                    retryRequest = function (err) { return __awaiter(_this, void 0, void 0, function () {
                        var sendableRes, _a, headers, data, status, _b, _c, serverRetryAfter, _d, retryLimit, _e, rateLimitRemaining, _f, resetAfter, check, exponentialRetryAfterTime, retryAfter, rateLimitInfo;
                        return __generator(this, function (_g) {
                            switch (_g.label) {
                                case 0:
                                    callback(err, null, {
                                        isRetry: findIsRetry(),
                                        isLoading: false,
                                    });
                                    sendableRes = typeOfRequest === 'Axios' ? err === null || err === void 0 ? void 0 : err.response : err;
                                    if (!sendableRes) {
                                        throw err;
                                    }
                                    return [4 /*yield*/, (0, exports.getGracefulProps)({
                                            typeOfRequest: typeOfRequest,
                                            response: sendableRes,
                                        })];
                                case 1:
                                    _a = _g.sent(), headers = _a.headers, data = _a.responseBody, status = _a.status;
                                    _b = (0, scenarios_1.checkHeaderAndBody)(data, headers) || {}, _c = _b.retryAfter, serverRetryAfter = _c === void 0 ? 0 : _c, _d = _b.retryLimit, retryLimit = _d === void 0 ? 0 : _d, _e = _b.rateLimitRemaining, rateLimitRemaining = _e === void 0 ? 0 : _e, _f = _b.resetAfter, resetAfter = _f === void 0 ? { deltaSeconds: 0 } : _f, check = _b.check;
                                    exponentialRetryAfterTime = (0, scenarios_1.exponentialBackOff)(status, check, retryAttempts, options === null || options === void 0 ? void 0 : options.exponentialBackOffFn).retryAfter;
                                    retryAfter = exponentialRetryAfterTime
                                        ? exponentialRetryAfterTime
                                        : serverRetryAfter;
                                    rateLimitInfo = {
                                        retryAfter: retryAfter,
                                        retryLimit: retryLimit,
                                        rateLimitRemaining: rateLimitRemaining,
                                        resetAfter: resetAfter,
                                    };
                                    if (!(options === null || options === void 0 ? void 0 : options.enableRetry)) {
                                        callback(__assign(__assign({}, err), { rateLimitInfo: rateLimitInfo }), null, {
                                            isRetry: findIsRetry(),
                                            isLoading: false,
                                        });
                                        throw err;
                                    }
                                    if (!retryAfter) {
                                        throw err;
                                    }
                                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, retryAfter * 1000); })];
                                case 2:
                                    _g.sent();
                                    callback(__assign(__assign({}, err), { rateLimitInfo: rateLimitInfo }), null, {
                                        isRetry: findIsRetry(),
                                        isLoading: false,
                                    });
                                    if (!(retryAttempts < retryLimit || (!check && !retryLimit))) return [3 /*break*/, 4];
                                    return [4 /*yield*/, gracefulRequest(typeOfRequest, requestFnc, callback, options, retryAttempts + 1)];
                                case 3: return [2 /*return*/, _g.sent()];
                                case 4: throw err;
                            }
                        });
                    }); };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 5]);
                    if (!findIsRetry()) {
                        callback(null, null, {
                            isRetry: findIsRetry(),
                            isLoading: true,
                        });
                    }
                    return [4 /*yield*/, requestFnc()];
                case 2:
                    response = _a.sent();
                    if ('ok' in response && !response.ok) {
                        throw response;
                    }
                    callback(null, response, {
                        isRetry: findIsRetry(),
                        isLoading: false,
                    });
                    return [2 /*return*/, response];
                case 3:
                    err_1 = _a.sent();
                    return [4 /*yield*/, retryRequest(err_1)];
                case 4: return [2 /*return*/, _a.sent()];
                case 5: return [2 /*return*/];
            }
        });
    });
}
exports.gracefulRequest = gracefulRequest;
